import React from 'react'
import "./Footer.css"
import FacebookIcon from '@mui/icons-material/Facebook'
import InstagramIcon from '@mui/icons-material/Instagram'
import { Icon } from '@iconify/react';
import slackIcon from '@iconify/icons-mdi/slack';
import logo from '../assets/logo.png';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <div className="footer">
      <div className="logo">
          <Link to="/"><img src={logo} alt="logo" /></Link>
      </div>

      <div className="address-container">
        <p><b><u>Maker Garage and Study Spot</u></b></p>
        <p>MAEB 334</p>
      </div>
      
      <div className="social">
        <Icon className="social-icons" icon="tabler:brand-linktree" width="25" onClick={() => window.open('https://linktr.ee/weceuf')}/>
        <Icon className="social-icons" icon={slackIcon} width="25" onClick={() => window.open('https://wecegroup.slack.com/join/shared_invite/zt-1eudrc63r-GumP2W1my7cSPOwAIYkFAw#/shared-invite/email')}/>
        <FacebookIcon className="social-icons" onClick={() => window.open('https://www.facebook.com/groups/434483479998047/')}/>
        <InstagramIcon className="social-icons" onClick={() => window.open('https://www.instagram.com/wece_uf/')}/>
      </div> 
    </div>
  )
}

export default Footer